import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import DateControl from '../../components/Fields/DateControl';
import Field from '../../components/Fields/Field';
import FieldLabel from '../../components/Fields/FieldLabel';
import Form from '../../components/Fields/Form';
import TextboxField from '../../components/Fields/TextboxField';
import { FieldConfig, FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import SpinnerOverlay from '../../components/Spinner/SpinnerOverlay';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import GenderModel from '../../models/GenderModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';

const GenderView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const [formData, setFormData] = useState<GenderModel>();

    let genderId = 0;
    let idParams: IdParams = useParams();
    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        genderId = parseInt(idParams.id);
    }

    useEffect(() => {
        if (genderId !== undefined) {
            DataService.getById<GenderModel>('api/v1/Genders/', genderId)
                .then(response => {
                    setFormData(response);
                })
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [genderId]);

    function submit() {
        if (formData) {
            DataService
                .update<GenderModel>(`api/v1/Genders/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);
                })
                .catch(e => handleException(e));
        }
    }

    let fields: FieldConfig[] = [
        { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }, { type: 'isMaxLength', maxLength: 250 }] },
        { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
        { name: 'endDate', label: 'Active Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
    ];

    const formConfig: FormConfig = {
        fields: fields,
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getLabelProps, getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);
    const { isAuthorizedFor } = useAuth();


    if (genderId === undefined) {
        if (!isAuthorizedFor(ApplicationFunctions.EditGender)) {
            return (<Unauthorized />);
        }
    }
    else if (!isAuthorized) {
        return (<Unauthorized />);
    }

    if (!formData)
        return <SpinnerOverlay />

    return (
        <div className='main-content'>
            <Form
                title={formData.name}
                footer={(
                    <ButtonBar offset={2}>
                        <Authorize applicationFunction={ApplicationFunctions.EditGender} >
                            <SaveButton  {...getSubmitButtonProps()} />
                        </Authorize>
                    </ButtonBar>
                )}>
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <TextboxField {...getFieldProps('name')} />
                            <Field {...getLabelProps('beginDate')}>
                                <DateControl {...getControlProps('beginDate')} />
                                <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                                <DateControl {...getControlProps('endDate')} />
                            </Field>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </div>
    );
}
export default GenderView;